const APP = {
	name: 'SeoZoom by eazyweb'
};